import { render, staticRenderFns } from "./MainLeftBlock.vue?vue&type=template&id=5f0b9737&scoped=true&"
import script from "./MainLeftBlock.vue?vue&type=script&lang=js&"
export * from "./MainLeftBlock.vue?vue&type=script&lang=js&"
import style0 from "./MainLeftBlock.vue?vue&type=style&index=0&id=5f0b9737&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b9737",
  null
  
)

export default component.exports